function initIngredientsSlider() {

  const sliders = document.querySelectorAll('.ingredients-slider');

  if (!sliders.length) return;

  sliders.forEach((slider) => {

    if (slider.classList.contains('is-initialized')) return;

    slider.classList.add('is-initialized');

    new Splide(slider, {
      type       : 'slide',
      perPage    : 4,
      perMove    : 1,
      gap        : '24px',
      pagination : false,
      arrows     : true,

      breakpoints: {
        1024: {
          perPage: 3,
        },

        768: {
          perPage: 2,
        },

        600: {
          perPage: 1,
        }
      }

    }).mount();

  });

}

document.addEventListener('DOMContentLoaded', initIngredientsSlider);
document.addEventListener('shopify:section:load', initIngredientsSlider);
document.addEventListener('shopify:block:select', initIngredientsSlider);